// extracted by mini-css-extract-plugin
export var wrap = "CookiesBanner-module--wrap--3vQtZ";
export var text = "CookiesBanner-module--text--WuDaz";
export var button = "CookiesBanner-module--button--3csoX";